import {createContext} from 'react';

export const AlertContext = createContext("")

export const LanguageContext = createContext("")